import React, {useCallback, useState} from 'react';
import { useField } from 'formik';
import { useTranslation } from 'react-i18next';
import { CheckBox } from '../checkbox';
import { Input } from 'src/components/input';
import { useFormikContext } from 'formik';


export function ReportCopy(props) {
  const { name, inputName, text, placeholder } = props;
  const [field, meta, helpers] = useField(name);
  const { t } = useTranslation();
  const formikProps = useFormikContext();
  const [email, setEmail] = useState('');

  const { setValue } = helpers;
  const handleChange = useCallback(() => {
    // checkbox remove and restore input field value

    // if(reset && field.value){
    //   setEmail(formikProps.getFieldProps().value[inputName]);
    //   formikProps.setFieldValue(inputName, '');
    // }
    // else {
    //   formikProps.setFieldValue(inputName, email);
    //   setEmail('');
    // }

    formikProps.setFieldValue(
      inputName, 
      field.value ? '' : email
    );
    
    setEmail(field.value 
      ? formikProps.getFieldProps().value[inputName]
      : ''
    );

    setValue(!field.value);
  }, [setValue, field.value])

  return (
    <>
      <CheckBox
        key={name}
        name={name}
        onClick={handleChange}
        checked={field.value}
      >
        {t(text)}
      </CheckBox>
      {field.value && 
        <Input
          name={inputName}
          placeholder={placeholder}
        />
      }
    </>
  )
}
